import { render, staticRenderFns } from "./Groundwater.vue?vue&type=template&id=d5177a22"
import script from "./Groundwater.vue?vue&type=script&lang=js"
export * from "./Groundwater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports